import classNames from "classnames/bind";
import styles from "./TableAdminNotification.module.css";
import PropTypes from 'prop-types';
import { Loading, Switch } from "../../../../components";
import axiosClient from "../../../../services/axiosClient";
import { sorterArray } from "../../../../utils";
import { useEffect, useState } from "react";
import NameCol from "../../../../components/NameCol";
import { BellIcon, EmailIcon, TelegramIcon } from "../../../../components/Icons/NotificationSetting";

const cx = classNames.bind(styles);

function TableAdminNotification({ showDetailInfo, notifications, setIsLoading, isLoading, setShowModal, setTypeNotification, setTitle }) {
    const [toggleSort, setToggleSort] = useState(false)
    const [method, setMethod] = useState('')


    const handleChangeStatus = async (e, code) => {
        setIsLoading(true)
        const statusActive = e ? '1' : '0'
        const res = await axiosClient.put(`/typeNotification/put-change-user-active-notification-active/?type_notification_code=${code}`, {
            active: statusActive
        })
        setIsLoading(false)
        return res
    }

    const handleSort = (type, method) => {
        if (type !== toggleSort) {
            setToggleSort(type)
            setMethod(method)
        } else {
            setToggleSort(false)
            setMethod('')
        }
    }
    const handleShowModal = (code, title) => {
        setShowModal(true)
        setTypeNotification(code)
        setTitle(title)
    }
    return (
        <>
            <table className={cx('table-notification')}>
                <thead>
                    <tr>
                        <th className={cx('center')}>STT</th>
                        <th>
                            <NameCol active={method} title={'Thông báo'} handleSort={handleSort} method={'DETAIL'} />
                        </th>
                        <th>
                            <NameCol active={method} title={'Mức độ'} handleSort={handleSort} method={'LEVEL'} />
                        </th>
                        <th >
                            <NameCol active={method} title={'Người nhận'} handleSort={handleSort} method={'COUNT_USER'} />
                        </th>
                        <th className={cx('center')}>
                            Kênh thông báo
                        </th>
                        <th className={cx('center')}>Kích hoạt</th>
                    </tr>
                </thead>
                <tbody className={cx('body-table')}>
                    {notifications && notifications?.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td >
                                    <div className={cx('center')}>{index + 1}</div>
                                </td>
                                <td>
                                    <span className={cx('name-notification')}>{item.DETAIL}</span>
                                </td>

                                <td>
                                    <span style={{ fontSize: 14 }}>Thấp</span>
                                </td>
                                <td className={cx("link")} onClick={() => handleShowModal(item.CODE, item.DETAIL)}>
                                    <div className={cx('count-user')}>{item.COUNT}</div>
                                </td>
                                <td>
                                    <div style={{ display: "flex", gap: 10, justifyContent: 'center' }}>
                                        <span><BellIcon /></span>
                                        <span><TelegramIcon /></span>
                                        <span><EmailIcon /></span>
                                    </div>
                                </td>
                                <td>
                                    <div className={cx('center')}>
                                        <Switch type="small" value={item.ACTIVE === 1 ? true : false} onChange={e => handleChangeStatus(e, item.CODE)} />
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {isLoading &&
                <div className={cx('loading-modal')}>
                    <Loading />
                </div>
            }
        </>
    )
}

TableAdminNotification.propTypes = {
    showDetailInfo: PropTypes.func
}
export default TableAdminNotification;